import React, { useState, useEffect } from 'react';
import axios from "axios";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import './CultureAttributesView.css'

import { apiUrl } from '../../../utility/Connections';

import { Typography, Layout, Divider, Button, Input, Modal, Tag, message, Space } from 'antd';
import FileUploaderAuto from '../../../components/fileUploader/fileUploaderAuto';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import Search from '../../../components/search/search';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import TableCultureAttributes from '../../../components/tableCultureAttributes/tableCultureAttributes';
import { DeleteOutlined, PlusSquareOutlined } from '@ant-design/icons';
import ModalCultureAttribute from '../../../components/modalCultureAttribute/modalCultureAttribute';
const { Paragraph, Title } = Typography;
const { Content } = Layout;

const CultureAttributesView = () => {

    const [fileCharged, setFileCharged] = useState(false)
    const [orgId, setOrgId] = useState(false)
    const [dataCultureAttributes, setDataCultureAttributes] = useState([])
    const [filteredDataCultureAttributes, setFilteredDataCultureAttributes] = useState([])
    const [searchTextCultureAttribute, setSearchTextCultureAttribute] = useState("")
    const [dataCultureAttributesLevels, setDataCultureAttributesLevels] = useState([])
    const [selectedFile, setSelectedFile] = useState("")
    const [showLoading, setShowLoading] = useState(false)
    const [loadingText, setLoadingText] = useState("")

    const [newCultureAttribute, setNewCultureAttribute] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
    const [bulkDeleteConfirmCode, setBulkDeleteConfirmCode] = useState("");

    // States para el modal de atributos culturales
    const [catId, setCatId] = useState(null);
    const [catAttribute, setCatAttribute] = useState("");
    const [catDescription, setCatDescription] = useState("");
    const [catType, setCatType] = useState("");
    const [catBehaviors, setCatBehaviors] = useState([]);
    const [dataCultureAttribute, setDataCultureAttribute] = useState({});

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            getCultureAttributes(current_org.org_id);
        }
    }, []);

    // Función para asignar valores del backend a los estados
    useEffect(() => {
        if (dataCultureAttribute) {
            setCatId(dataCultureAttribute.cat_id || null);
            setCatAttribute(dataCultureAttribute.cat_attribute || "");
            setCatDescription(dataCultureAttribute.cat_description || "");
            setCatType(dataCultureAttribute.cat_type || "");
            setCatBehaviors(dataCultureAttribute.cat_behaviors || []);
        }
    }, [dataCultureAttribute]);

    const handleChangeFile = () => {
        setFileCharged(false)
    }

    const selectFile = (files) => {
        setSelectedFile(files[0])
        setFileCharged(true)
    }

    const getCultureAttributes = async (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando información. Esto puede tardar un poco...");

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/culture-attributes/get-culture-attributes/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataCultureAttributes(data);
                if (searchTextCultureAttribute) {
                    filterDataCultureAttribute(searchTextCultureAttribute, data)
                } else {
                    setFilteredDataCultureAttributes(data);
                }
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const uploadFile = async () => {
        setShowLoading(true);
        setLoadingText("Guardando atributos culturales. Esto puede tardar un poco...");

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("org_id", orgId);

        const token = localStorage.getItem('access_token');
        
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        }

        axios
            .post(`${apiUrl}/files/upload-culture-attributes/`, formData, headers)
            .then(function (response) {
                // getUploadedFiles();
                resetStates();
                getCultureAttributes(orgId);
                showSwal(response.data.message, 2, "Correcto");
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false)
                showSwal(`Error: ${error}`, 0, "Error");
                console.error(`Error: ${error}`);
            });
    };

    const resetStates = () => {
        setFileCharged(false)
        setSelectedFile("")
    }

    const onSearchCultureAttribute = (value) => {
        setSearchTextCultureAttribute(value)
        filterDataCultureAttribute(value, dataCultureAttributes)
    }

    const filterDataCultureAttribute = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataCultureAttributes(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.cat_attribute.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataCultureAttributes(filtered);
        }
    }

    const setCultureAttributeValuesToSee = (cat) => {
        setShowLoading(true);
        setNewCultureAttribute(false);
        setLoadingText("Cargando información del atributo cultural...")
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .get(`${apiUrl}/culture-attributes/get-culture-attribute-by-id/${cat.cat_id}/`, headers)
            .then(function (response) {
                const data = response.data.culture_attribute
                setNewCultureAttribute(false);
                setModalVisible(true);
                setDataCultureAttribute(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const openNewCultureAttribute = () => {
        let objCultureAttribute = {
            cat_id: null,
            cat_attribute: "",
            cat_description: "",
            cat_type: "Atributo de Cultura", // Valor por defecto
            cat_behaviors: [],
        }
        setDataCultureAttribute(objCultureAttribute);
        setNewCultureAttribute(true);
        setModalVisible(true);
    }

    const saveCultureAttribute = () => {
        setShowLoading(true);
        setLoadingText("Guardando edición del atributo...")
        setModalVisible(false);

        // Preparar datos en formato JSON según documentación del backend
        const requestData = {
            cat_org_id: orgId,
            cat_id: catId,
            cat_attribute: catAttribute,
            cat_description: catDescription,
            cat_type: catType,
            cat_behaviors: catBehaviors
        };

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        }
        axios
            .post(`${apiUrl}/culture-attributes/save-culture-attribute/`, requestData, headers)
            .then(function (response) {
                setNewCultureAttribute(false);
                showSwal(response.data.message, 2, "Correcto");
                setModalVisible(false);
                getCultureAttributes(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setModalVisible(true);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const createCultureAttribute = () => {
        setShowLoading(true);
        setLoadingText("Guardando atributo cultural...")
        
        // Preparar datos en formato JSON según documentación del backend
        const requestData = {
            cat_org_id: orgId,
            cat_attribute: catAttribute,
            cat_description: catDescription,
            cat_type: catType,
            cat_behaviors: catBehaviors
        };

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        }
        axios
            .post(`${apiUrl}/culture-attributes/save-culture-attribute/`, requestData, headers)
            .then(function (response) {
                setNewCultureAttribute(false);
                setModalVisible(false);
                showSwal(response.data.message, 2, "Correcto");
                getCultureAttributes(orgId);
                // setShowLoading(false);
            })
            .catch(function (error) {
                // showSwal(error.data.error, 0, "Error");
                console.error('There was an error!', error);
                // setModalVisible(true);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const bulkDeleteCode = "ELIMINAR";

    const handleBulkDelete = () => {
        if (bulkDeleteConfirmCode !== bulkDeleteCode) {
            message.error(`Debe escribir "${bulkDeleteCode}" para confirmar`);
            return;
        }

        setShowBulkDeleteModal(false);
        setBulkDeleteConfirmCode("");
        setShowLoading(true);
        setLoadingText("Eliminando todos los atributos culturales...");

        const token = localStorage.getItem('access_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        axios
            .delete(`${apiUrl}/culture-attributes/bulk-delete-culture-attributes/${orgId}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Eliminación completada");
                getCultureAttributes(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false);
                const resp = error.response;
                showSwal(resp?.data?.error || `Error: ${error.message}`, 0, "Error");
            });
    };

    const handleDeleteAllBehaviors = (catId) => {
        const token = localStorage.getItem('access_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        setModalVisible(false);
        setShowLoading(true);
        setLoadingText("Eliminando todos los comportamientos del atributo...");

        axios
            .delete(`${apiUrl}/culture-attributes/bulk-delete-culture-behaviors/${catId}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Eliminación completada");
                getCultureAttributes(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false);
                const resp = error.response;
                showSwal(resp?.data?.error || `Error: ${error.message}`, 0, "Error");
            });
    };

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            {/* <SideMenuAdmin /> */}
            <div className='layout-content'>
                <Typography className='display-center-row display-center-column'>
                    <Title type='primary' level={3}>Carga de atributos culturales</Title>
                    <Paragraph>
                        Configure y cargue sus archivos desde esta sección. Siga los siguientes pasos:
                        <ol style={{ marginTop: 10, marginBottom: 10 }}>
                            <li>Da click en el cargador o arrastra tu archivo a la zona de carga del archivo</li>
                            <li>Da click en el botón "Cargar atributos culturales"</li>
                        </ol>
                    </Paragraph>
                </Typography>
                <div className='display-center-row display-center-column align-full-center'>
                    <div style={{ width: "80%", backgroundColor: "white" }} className='display-center-row main-subcontainer'>
                        {
                            fileCharged ? <div className='display-center-row display-center-column align-full-center uploader-container' >
                                <p className='filename-tag'>{selectedFile.name}</p>
                                <Button style={{ width: 'auto' }} type="primary" danger onClick={handleChangeFile}>Cambiar archivo</Button>
                            </div> : <div className='display-center-row display-center-column uploader-container'>
                                <FileUploaderAuto mostrarData={selectFile} multi={false} openSwal={showSwal} uploadFile={true} tamanoArchivo={100} />
                            </div>
                        }
                    </div>
                    <Button style={{ width: 'auto' }} type="primary" onClick={uploadFile} disabled={!fileCharged}>Cargar atributos culturales</Button>
                </div>
            </div>
            <Divider />
            <div className='layout-content'>
                <Typography className='display-center-row display-center-column'>
                    <Title type='primary' level={3}>Gestión de atributos culturales</Title>
                </Typography>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
                    <Space wrap>
                        <Button onClick={openNewCultureAttribute} icon={<PlusSquareOutlined />}>Crear atributo cultural</Button>
                        {dataCultureAttributes.length > 0 && (
                            <Button
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => { setShowBulkDeleteModal(true); setBulkDeleteConfirmCode(""); }}
                            >
                                {`Eliminar todos los atributos (${dataCultureAttributes.length})`}
                            </Button>
                        )}
                    </Space>
                </div>
                <Divider />
                <Search onSearch={onSearchCultureAttribute} />
                <br></br>
                <div className='display-center-row display-center-column'>
                    <TableCultureAttributes data={filteredDataCultureAttributes} setCultureAttributeValuesToSee={setCultureAttributeValuesToSee} />
                </div>
            </div>
        </Content>
        <ModalCultureAttribute
            visible={modalVisible}
            onClose={() => setModalVisible(false)}
            states={{
                catId, catAttribute, catDescription, catType, catBehaviors
            }}
            setters={{
                setCatId, setCatAttribute, setCatDescription, setCatType, setCatBehaviors
            }}
            newCultureAttribute={newCultureAttribute}
            saveCultureAttribute={saveCultureAttribute}
            createCultureAttribute={createCultureAttribute}
            onDeleteAllBehaviors={handleDeleteAllBehaviors}
        />

        <Modal
            title={`Eliminar todos los atributos culturales (${dataCultureAttributes.length})`}
            open={showBulkDeleteModal}
            onCancel={() => setShowBulkDeleteModal(false)}
            onOk={handleBulkDelete}
            okText="Confirmar eliminación"
            cancelText="Cancelar"
            okButtonProps={{ danger: true, disabled: bulkDeleteConfirmCode !== bulkDeleteCode }}
            destroyOnClose
        >
            <Typography.Text style={{ display: 'block', marginBottom: 12 }}>
                Esta acción eliminará todos los {dataCultureAttributes.length} atributos culturales y sus comportamientos asociados. Esta acción no se puede deshacer.
            </Typography.Text>
            <Typography.Text strong style={{ display: 'block', marginBottom: 8 }}>
                Escriba <Tag color="red">{bulkDeleteCode}</Tag> para confirmar:
            </Typography.Text>
            <Input
                value={bulkDeleteConfirmCode}
                onChange={(e) => setBulkDeleteConfirmCode(e.target.value)}
                placeholder={`Escriba ${bulkDeleteCode}`}
                onPressEnter={handleBulkDelete}
            />
        </Modal>
    </div>
}

export default CultureAttributesView;